var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 17.5H4.375C3.4085 17.5 2.625 16.7165 2.625 15.75V3.5C2.625 2.5335 3.4085 1.75 4.375 1.75H16.625C17.5915 1.75 18.375 2.5335 18.375 3.5V15.75C18.375 16.7165 17.5915 17.5 16.625 17.5H15.3125M10.5 16.625C11.9497 16.625 13.125 15.4497 13.125 14C13.125 12.5503 11.9497 11.375 10.5 11.375C9.05025 11.375 7.875 12.5503 7.875 14C7.875 15.4497 9.05025 16.625 10.5 16.625ZM10.5 16.625L10.5188 16.6248L7.72509 19.4185L5.25021 16.9436L7.8922 14.3016M10.5 16.625L13.2937 19.4185L15.7686 16.9436L13.1266 14.3016M7.875 5.25H13.125M6.125 8.3125H14.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateActive);
export default __webpack_public_path__ + "static/media/certificate-active.a6c56ece78d87df9d296f6ec97bad925.svg";
export { ForwardRef as ReactComponent };